import { BehaviorSubject, Observable, Subject } from 'rxjs';

export type THEME = 'darkMode' | 'lightMode';

let instance: ThemeOption;

export class ThemeOption {
  private mStream = new BehaviorSubject(null);

  public constructor() {
    if (instance) return instance;
    instance = this;
    const theme = localStorage.getItem('theme') as THEME;
    this.mStream.next(theme ?? 'darkMode');
  }

  public setTheme(opt: THEME): void {
    this.mStream.next(opt);
    localStorage.setItem('theme', opt);
  }

  public get stream(): Observable<THEME> {
    return this.mStream;
  }
}
